/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import * as dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { Link } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';

import tipIcon from '@assets/my-product-tip.png';
// import { Divider } from '@mui/material';
import useConnectionContext from '@hooks/useConnectionContext';
import { PRODUCT_NAME } from '@/constants';
import useProductsContext from '../../hooks/useProductsContext';
import classes from './ProductInvolved.module.css';

dayjs.extend(utc);
dayjs.extend(timezone);

const Card = ({
  status, name, liveDate, icon, settingHref, policyHref, connected = true,
}) => {
  if (status === undefined || status === null) {
    return null;
  }
  const colorMap = {
    pending: '#F1C600',
    inactive: '#A09F9C',
    active: '#645AFF',
  };
  // https://seel.atlassian.net/browse/OP-514
  const showBankTips = [PRODUCT_NAME.RETURN_ASSURANCE, PRODUCT_NAME.RETURNABLE].includes(name) && ['inactive', 'active'].includes(status) && !connected;
  return (
    <div className={classes.item}>
      {showBankTips
        && (
          <div className={classes.bank_tip}>
            <span className={classes.bank_tip_icon}>!</span>
            You haven‘t set up any payment methods yet
          </div>
        )}
      <div className={classes.name_line}>
        <img className={classes.name_line_icon} src={icon} alt="" />
        <div className={classes.name_line_text}>{name}</div>
        <div
          className={classes.name_line_status}
          style={{
            backgroundColor: colorMap[status],
          }}
        >
          {status}
        </div>
      </div>
      <div className={classes.item_entrys}>

        {/* OP RA pending & active&inactive状态下，My products section可见 RA “Settings“入口 */}
        {['pending', 'active', 'inactive'].includes(status) && (
          <>
            {policyHref
              ? <Link to={policyHref}><div className={classes.item_entry}>View Covers</div></Link>
              : null}
            {settingHref && settingHref === 'soon' ? <span className={classes.item_soon}>Settings</span>
              : <Link to={settingHref}><div className={classes.item_entry}>Settings</div></Link>}
          </>
        )}

        {
          status === 'pending' || (status === 'inactive' && !showBankTips)
            ? (
              <div className={classes.item_tips}>
                <img src={tipIcon} className={classes.item_tips_icon} alt="" />
                <div style={{ width: 10, height: 10 }} />
                <div className={classes.item_tips_text}>{status === 'pending' ? 'Application is under review' : `Go-live date is ${dayjs.utc(liveDate).tz('America/New_York').format('MMM DD, YYYY hh:mm a')} (ET)`}</div>
              </div>
            ) : null
        }
      </div>
    </div>
  );
};

export default function ProductInvolved() {
  const { productsInvolved, involvedLoading } = useProductsContext();
  const { payment } = useConnectionContext();
  const { connected } = payment;

  if (involvedLoading) {
    return (
      <div className={classes.involved_container}>
        <div className={classes.involved_title}>My Product</div>
        <Skeleton count={2} style={{ height: '20px', width: '100%', marginTop: '5px' }} />
      </div>
    );
  }

  if (!productsInvolved.length) {
    return (
      <div className={classes.involved_container}>
        <div className={classes.involved_title}>My Product</div>
        <div className={classes.involved_empty}>No product here. Please choose a Seel product.</div>
      </div>
    );
  }

  return (
    <div className={classes.involved_container}>
      <div className={classes.involved_title}>My Product</div>
      {productsInvolved.map((item, index) => (
        // eslint-disable-next-line no-sequences
        <Card key={item.name} {...item} connected={connected} />
        // <>
        //   {
        //     index !== 0 && index !== productsInvolved.length - 1
        //       ? (
        //         <Divider
        //           sx={{
        //             marginTop: '10px',
        //           }}
        //           key={`divider-${item.name}}`}
        //         />
        //       )
        //       : null
        //   }
        //   <Card key={item.name} {...item} />
        // </>
      ))}
      {/* {!connected
        && (
          <div className={classes.bank_tip}>
            <span className={classes.bank_tip_icon}>!</span>
            You haven‘t set up any payment methods yet
          </div>
        )} */}
    </div>
  );
}
